import * as $runtime from "../runtime.js";
import * as Affjax from "../Affjax/index.js";
import * as Affjax$dResponseFormat from "../Affjax.ResponseFormat/index.js";
import * as Affjax$dWeb from "../Affjax.Web/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Foreign from "../Foreign/index.js";
const $RemoteError = (tag, _1) => ({tag, _1});
const show = /* #__PURE__ */ (() => Data$dList$dTypes.showNonEmptyList(Foreign.showForeignError).show)();
const genericShowSum = /* #__PURE__ */ (() => {
  const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["(StatusCode " + Data$dShow.showIntImpl(v) + ")"]})({reflectSymbol: () => "ServerError"});
  return dictGenericShow1 => (
    {
      "genericShow'": v => {
        if (v.tag === "Inl") { return $0["genericShow'"](v._1); }
        if (v.tag === "Inr") { return dictGenericShow1["genericShow'"](v._1); }
        $runtime.fail();
      }
    }
  );
})();
const genericShowSum1 = /* #__PURE__ */ (() => {
  const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "NetworkError"});
  return dictGenericShow1 => (
    {
      "genericShow'": v => {
        if (v.tag === "Inl") { return $0["genericShow'"](v._1); }
        if (v.tag === "Inr") { return dictGenericShow1["genericShow'"](v._1); }
        $runtime.fail();
      }
    }
  );
})();
const genericShowSum2 = /* #__PURE__ */ (() => {
  const $0 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Data$dShow.showStringImpl(v)]})({reflectSymbol: () => "DecodingError"});
  return dictGenericShow1 => (
    {
      "genericShow'": v => {
        if (v.tag === "Inl") { return $0["genericShow'"](v._1); }
        if (v.tag === "Inr") { return dictGenericShow1["genericShow'"](v._1); }
        $runtime.fail();
      }
    }
  );
})();
const ApplicationErrorIsSymbol = {reflectSymbol: () => "ApplicationError"};
const ServerError = value0 => $RemoteError("ServerError", value0);
const NetworkError = /* #__PURE__ */ $RemoteError("NetworkError");
const DecodingError = value0 => $RemoteError("DecodingError", value0);
const ApplicationError = value0 => $RemoteError("ApplicationError", value0);
const simpleRequest = request => decode => Effect$dAff._map(v => {
  if (v.tag === "Left") { return Data$dEither.$Either("Left", NetworkError); }
  if (v.tag === "Right") {
    if (v._1.status === 200) {
      const v1 = decode(v._1.body);
      if (v1.tag === "Left") { return Data$dEither.$Either("Left", $RemoteError("DecodingError", show(v1._1))); }
      if (v1.tag === "Right") { return Data$dEither.$Either("Right", v1._1); }
      $runtime.fail();
    }
    return Data$dEither.$Either("Left", $RemoteError("ServerError", v._1.status));
  }
  $runtime.fail();
})(Affjax.request(Affjax$dWeb.driver)({...request, responseFormat: Affjax$dResponseFormat.$ResponseFormat("String", Affjax$dResponseFormat.identity)}));
const genericRemoteError = {
  to: x => {
    if (x.tag === "Inl") { return $RemoteError("ServerError", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return NetworkError; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return $RemoteError("DecodingError", x._1._1._1); }
        if (x._1._1.tag === "Inr") { return $RemoteError("ApplicationError", x._1._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ServerError") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "NetworkError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "DecodingError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1))); }
    if (x.tag === "ApplicationError") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1))); }
    $runtime.fail();
  }
};
const genericShow = dictGenericShow => x => dictGenericShow["genericShow'"](genericRemoteError.from(x));
const showRemoteError = dictShow => (
  {
    show: genericShow(genericShowSum(genericShowSum1(genericShowSum2(Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [dictShow.show(v)]})(ApplicationErrorIsSymbol)))))
  }
);
const fromApplicationError = v => {
  if (v.tag === "ApplicationError") { return Data$dMaybe.$Maybe("Just", v._1); }
  return Data$dMaybe.Nothing;
};
const eqRemoteError = dictEq => (
  {
    eq: x => y => {
      const $0 = genericRemoteError.from(x);
      const $1 = genericRemoteError.from(y);
      if ($0.tag === "Inl") {
        if ($1.tag === "Inl") { return $0._1 === $1._1; }
        return false;
      }
      if ($0.tag === "Inr") {
        if ($1.tag === "Inr") {
          if ($0._1.tag === "Inl") { return $1._1.tag === "Inl"; }
          if ($0._1.tag === "Inr") {
            if ($1._1.tag === "Inr") {
              if ($0._1._1.tag === "Inl") {
                if ($1._1._1.tag === "Inl") { return $0._1._1._1 === $1._1._1._1; }
                return false;
              }
              if ($0._1._1.tag === "Inr") {
                if ($1._1._1.tag === "Inr") { return dictEq.eq($0._1._1._1)($1._1._1._1); }
                return false;
              }
              return false;
            }
            return false;
          }
          return false;
        }
        return false;
      }
      return false;
    }
  }
);
export {
  $RemoteError,
  ApplicationError,
  ApplicationErrorIsSymbol,
  DecodingError,
  NetworkError,
  ServerError,
  eqRemoteError,
  fromApplicationError,
  genericRemoteError,
  genericShow,
  genericShowSum,
  genericShowSum1,
  genericShowSum2,
  show,
  showRemoteError,
  simpleRequest
};
